import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { blockReasonLabel } from '../../changelogAdminConfig';

/**
 * Novidades que não mudaram de status, com o motivo devolvido pela API.
 * @param {{ blocked: Array<{ id, title, reason }>, onClose: Function }} props
 */
function BlockedItemsAlert({ blocked, onClose }) {
  if (blocked.length === 0) return null;
  return (
    <Alert severity="warning" onClose={onClose} sx={{ borderRadius: 0 }}>
      <strong>{blocked.length} novidade(s) não mudaram:</strong>
      <Box component="ul" sx={{ m: 0, mt: 0.5, pl: 2.5 }}>
        {blocked.map((entry) => (
          <li key={entry.id}>{entry.title}: {blockReasonLabel(entry.reason)}</li>
        ))}
      </Box>
    </Alert>
  );
}

export default BlockedItemsAlert;
